/* =============================================
   XXTRA ARMOR — THEME JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  /* --- Mobile menu toggle --- */
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const navLinks = document.querySelector('.nav-links');
  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', () => {
      navLinks.classList.toggle('nav-links--open');
    });
  }

  /* --- Quantity selectors --- */
  document.querySelectorAll('.qty-selector').forEach(el => {
    const minus = el.querySelector('[data-qty="minus"]');
    const plus = el.querySelector('[data-qty="plus"]');
    const input = el.querySelector('input');
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    plus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });

  /* --- Scroll animations (IntersectionObserver) --- */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-up');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));

  /* --- AJAX Cart (add to cart) --- */
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.textContent : '';

      if (btn) {
        btn.textContent = 'Adding...';
        btn.disabled = true;
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });
        const data = await res.json();

        if (btn) {
          btn.textContent = 'Added ✓';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        }

        updateCartCount();
      } catch (err) {
        console.error('Cart add error:', err);
        if (btn) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      }
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (err) {
      console.error('Cart count error:', err);
    }
  }
});
